export const CHANGE_PAGE = 'CHANGE_PAGE'
export const GO_TO_PAGE = 'GO_TO_PAGE'
export const INITIALIZE_PAGE = 'INITIALIZE_PAGE'
export const PageNumberParam = 'pageNumber'



// WEBPACK FOOTER //
// ./src/components/pager/constants.ts